import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  title: 'No results found',
  description: 'Please check your search query and try again.',
})
